import { CurrentProviderEzwmConfigurationRemoveCommand } from '@dreryk/egabinet-ezwm-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../../../translations';

const useCurrentProviderEzwmConfigurationRemoveCommand = (onSuccess: VoidFunction): UseCqrsCommandResult => {
   return useCqrsCommand(() => new CurrentProviderEzwmConfigurationRemoveCommand(), {
      onSuccess: () => {
         onSuccess();
         dispatchSnackbarPositiveEvent(nfzSettingsTranslationKeys.senderCodeRemoveSuccess);
      },
   });
};

type EzwmSenderCodeModalConfirmButtonProps = {
   readonly onSuccess: VoidFunction;
};

export const EzwmSenderCodeModalConfirmButton = (props: EzwmSenderCodeModalConfirmButtonProps): JSX.Element => {
   const { executeAsync: removeSenderCode } = useCurrentProviderEzwmConfigurationRemoveCommand(props.onSuccess);
   return (
      <ModalConfirmButton
         testId={'removeSenderCode'}
         onClick={removeSenderCode}
         label={nfzSettingsTranslationKeys.remove}
      />
   );
};
